import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { setTheme } from 'ngx-bootstrap/utils';
import {MenuComponent} from "src/app/components/menu/menu.component";
import { InstallSheetComponent } from 'src/app/components/install-sheet/install-sheet.component';
import { PwaService } from 'src/app/core/services/pwa.service';
import { APP_VERSION, BUILD_DATE, BUILD_ENV, GIT_SHA } from 'src/app/version';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, MenuComponent, InstallSheetComponent],
})
export class AppComponent implements OnInit {
  constructor(private store: Store, private pwa: PwaService) {
    setTheme('bs5');
  }

  ngOnInit(): void {
    // Initialize PWA listeners (Android/iOS)
    this.pwa.init();
    // Log build/version metadata (non-invasive check the generator works)
    try {
      // eslint-disable-next-line no-console
      console.log('[App Version]', { APP_VERSION, BUILD_ENV, BUILD_DATE, GIT_SHA });
    } catch {}
  }
}
